// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"274":"Home","884":"admin","933":"auth","966":"login"}[chunkId] || chunkId) + "." + {"109":"45fc100c","175":"3c288018","274":"894c15ac","285":"1901e6a4","421":"1bf62a96","720":"3905fca2","884":"41593e63","933":"bd302b1f","966":"93e5d97e"}[chunkId] + ".css";
};